module.exports = __webpack_public_path__ + "2980083682e94d33a66eef2e7d612519.svg";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/fontawesome-webfont.svg?v=4.3.0
// module id = 1154
// module chunks = 0